import { apiFetchJson } from '@wundo/client/api.ts';

/** A skill as the pickers on the admin tools list it. */
export interface SkillOption {
  id: string;
  name: string;
  description: string;
  recommendable: boolean;
}

/**
 * Every skill there is, name and all.
 *
 * `/skills/all` rather than the paginated list: these are dropdowns that have
 * to hold the whole set, and a skill catalogue is small enough to. Note that it
 * is *every* skill, recommendable or not — a broadcast may push an initial-only
 * skill, which is the one thing a recommendation run never does.
 */
export async function listAllSkills(): Promise<SkillOption[]> {
  const { data } = await apiFetchJson<{ data: SkillOption[] }>('/skills/all');
  return data;
}
